/* eslint-disable no-useless-computed-key */
import DownloadIcon from '@mui/icons-material/Download';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../../components/layout/Card';
import { Flex, Grid, MarginHandler } from '../../../styledComponents';
import ButtonCom from '../../../components/button/ButtonCom';
import TransitionsModal from '../../../components/modal/Modal';
import InputControl from '../../../components/input/InputControl';
import { FormControlLabel, Checkbox, FormGroup, FormControl, FormLabel, IconButton, Tooltip, Box, Typography, Button, Switch, LinearProgress, Tabs, Tab } from '@mui/material';
import { colors, fonts } from '../../../utils';
import FilledSelectOption from '../../../components/input/FilledSelectOption';
import { endPoints } from '../../../api/apiEndpoints';
import { Api } from '../../../api/api';
// import { setAllPostCategories } from '../../../redux/slices/posts/posts';
import { setAllSliders } from '../../../redux/slices/sliders/sliders';
import { errorNotify, successNotify } from '../../../utils/helper';
import Table from '../../../components/table/Table';
import EditIcon from '@mui/icons-material/Edit';
import ImageIcon from '@mui/icons-material/Image';
import DeleteIcon from '@mui/icons-material/Delete';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { useNavigate } from 'react-router-dom';
import DeleteModal from '../../../components/deletemodal/DeleteModal';
import VrpanoIcon from '@mui/icons-material/Vrpano';
import { setAllCompSpecNews, setAllGovNews, setAllPosts } from '../../../redux/slices/posts/posts';
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import moment from 'moment';


const PendingRequests = () => {
	const dispatch = useDispatch();
	const { clientId, userId, fullName } = useSelector((state) => state?.activeAccount);
	const { primaryFont } = fonts;

	const { colorWhite, colorPrimary, colorGreenGradient } = colors;

	const { posts, govNews, specificCompNews } = useSelector((state) => state?.posts);
	const [openModal, setOpenModal] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [tabValue, setTabValue] = useState('one');
	const navigate = useNavigate();

	const [formData, setFormData] = useState({
		name: '',
		description: '',
	});
	const [currentParams, setCurrentParams] = useState({
		limit: 10,
		page: 1,
		totalPages: 0,
		totalRecords: 0,
	});

	const handleChangeTab = (event, newValue) => {
		setTabValue(newValue);
	};

	const getPosts = async (limit, page) => {
		setIsLoading(true)
		try {

			await Api.post(endPoints?.posts?.fetch, {
				"clientId": null,
				"userId": null,
				"category_id": null,
				"nav_id": tabValue == "one" ? 1 : 2,
				"post_status": "pending",
				"limit": limit || 10,
				"page": page || 1

			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					dispatch(
						setAllPosts(
							response?.data?.data?.posts?.posts?.map((d, index) => ({
								index: index + 1,
								id: d?.id,
								title: d?.post_title,
								description: d?.post_content,
								post_status: d?.post_status,
								image: d?.image,
								category_id: d?.category_id,
								category_name: d?.category_name,
								dt: d?.post_date,
								url: d?.url,
								creator_id: d?.creator_id,
								creator_name: d?.creator_name,
							})
							),
						),
					);
					const { page, limit, totalPages, totalRecords } = response?.data?.data?.posts?.pagination;
					setCurrentParams({ page, limit, totalPages, totalRecords });
					setIsLoading(false)
				})
				.catch((error) => {
				});
		} catch (err) {
		}
	};
	const getGovNews = async (limit, page) => {
		setIsLoading(true)
		try {
			let params = {
				"type": "governance_news",
				"status": false,
				"limit": limit || 10,
				"page": page || 1
			}

			await Api.post(`${endPoints?.news?.fetch}`, params,
				{
					headers: {
						'xt-user-token': null
					}
				})
				.then((response) => {
					dispatch(
						setAllGovNews(
							response?.data?.data?.news?.news?.map((d, index) => ({
								index: index + 1,
								id: d?.id,
								title: d?.title,
								url: d?.url,
								description: d?.description,
								type: d?.type,
								image: d?.image,
								dt: d?.dt,
								creator_id: d?.creator_id,
								creator_name: d?.creator_name,

							})
							),
						),
					);
					const { page, limit, totalPages, totalRecords } = response?.data?.data?.news?.pagination;
					setCurrentParams({ page, limit, totalPages, totalRecords });
					setIsLoading(false)
				})
				.catch((error) => {
				});
		} catch (err) {
		}
	};
	const getSpecificNews = async () => {
		setIsLoading(true)
		try {

			await Api.get(`${endPoints?.news?.fetchCompNews}/false`, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					dispatch(
						setAllCompSpecNews(
							response?.data?.data?.news?.map((d, index) => ({
								index: index + 1,
								id: d?.id,
								title: d?.title,
								description: d?.description,
								type: d?.type,
								image: d?.image,
								dt: d?.dt,
								creator_id: d?.creator_id,
								creator_name: d?.creator_name,

							})
							),
						),
					);
					setIsLoading(false)
				})
				.catch((error) => {
				});
		} catch (err) {
		}
	};
	const onPostApprove = async (val) => {
		// setIsLoading(true)
		const { title, description, image, creator_id, creator_name, url, category_id, id } = val;
		let data1 = {
			post_title: title, post_content: description, image, creator_id, creator_name, url, category_id, id,
			post_status: 'publish',
		};

		let navId;
		if (tabValue == "one") {
			navId = 1
		} else {
			navId = 2
		}
		try {


			const data = {
				...data1,
				nav_id: navId

			};

			await Api.post(endPoints?.posts?.update, data, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					successNotify("Post Approved Successfully")
					getPosts();
				})
				.catch((error) => {

				});
		} catch (err) {
		}


	};
	const onPostReject = async (val) => {
		try {


			const data = {
				post_id: val.id,
				post_status: "draft"

			};

			await Api.post(endPoints?.posts?.statusUpdate, data, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					successNotify("Post Rejected Successfully")
					getPosts();
				})
				.catch((error) => {

				});
		} catch (err) {
		}


	};
	const onNewsApprove = async (val) => {
		// setIsLoading(true)
		const { title, description, url, image, creator_id, creator_name, type, id } = val;
		let data = {
			title, description, url, image, creator_id, creator_name, type, id,
			is_enabled: "true",
		};



		await Api.post(endPoints?.news?.update, data, {
			headers: {
				'xt-user-token': null
			}
		})
			.then((response) => {
				successNotify("News Approved Successfully")
				if (tabValue == "three") {
					getGovNews();
				} else {
					// getSpecificNews();
				}


			})
			.catch((error) => {

			});




	};

	const onNewsReject = async (val) => {
		try {


			const data = {
				is_deleted: true,
				id: val.id
			};

			await Api.post(endPoints?.news?.rejectNews, data, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					successNotify("News Rejected Successfully")
					if (tabValue == "three") {
						getGovNews();
					}
				})
				.catch((error) => {

				});
		} catch (err) {
		}


	};

	const postColumn = [
		{
			title: 'Id',
			field: 'id',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.id}</h4>,
		},
		{
			title: 'Title',
			field: 'title',
			render: (rowData) => <h4 className='font-face-B'>{rowData?.title}</h4>,
		},
		{
			title: 'Description',
			field: 'description',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.description}</h4>,
		},
		{
			title: 'Category Name',
			field: 'category_name',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.category_name}</h4>,
		},
		{
			title: 'Date',
			field: 'dt',
			render: (rowData) => <h4 className='font-face-R'>{moment(rowData?.dt).format("DD-MM-YYYY")}</h4>,
		},
		{
			title: 'Approve',
			field: 'approve',
			render: (rowData) => <h4 className='font-face-R'><ButtonCom btnTitle="Approve" onClickHandler={() => onPostApprove(rowData)} /></h4>,
		},
		{
			title: 'Reject',
			field: 'reject',
			render: (rowData) => <h4 className='font-face-R'><ButtonCom btnTitle="Reject" onClickHandler={() => onPostReject(rowData)} backgroundColor="#8B0000 !Important" /></h4>,
		},
	];
	const newsColumn = [
		{
			title: 'Id',
			field: 'id',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.id}</h4>,
		},
		{
			title: 'Title',
			field: 'title',
			render: (rowData) => <h4 className='font-face-B'>{rowData?.title}</h4>,
		},
		{
			title: 'Description',
			field: 'description',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.description}</h4>,
		},
		{
			title: 'Date',
			field: 'dt',
			render: (rowData) => <h4 className='font-face-R'>{moment(rowData?.dt).format("DD-MM-YYYY")}</h4>,
		},
		{
			title: 'Approve',
			field: 'approve',
			render: (rowData) => <h4 className='font-face-R'><ButtonCom btnTitle="Approve" onClickHandler={() => onNewsApprove(rowData)} /></h4>,
		},
		{
			title: 'Reject',
			field: 'reject',
			render: (rowData) => <h4 className='font-face-R'><ButtonCom btnTitle="Reject" onClickHandler={() => onNewsReject(rowData)} backgroundColor="#8B0000 !Important" /></h4>,
		},



	];


	useEffect(() => {
		tabValue == "one" && getPosts();
		tabValue == "two" && getPosts();
		tabValue == "three" && getGovNews();
		// tabValue == "four" && getSpecificNews();
	}, [tabValue])


	return (
		<>




			<Card margin='3rem 1.5rem' padding='3rem'>


				<Box sx={{ width: '100%' }}>
					<TabContext value={tabValue}>
						<Tabs
							value={tabValue}
							onChange={handleChangeTab}
							// textColor="secondary"
							// indicatorColor="secondary"
							sx={{
								".MuiButtonBase-root": {
									fontSize: "16px",
									fontFamily: primaryFont
								}
							}}
							aria-label="secondary tabs example"
						>
							<Tab value="one" label="Legal & Regulatory Posts" />
							<Tab value="two" label="Useful Resources Posts" />
							<Tab value="three" label="General News" />
							{/* <Tab value="four" label="Company Specific News" /> */}
						</Tabs>
						<TabPanel value="one">
							{isLoading ?
								<Box sx={{ m: '5rem' }}>
									<LinearProgress color="success" />
								</Box>
								:
								<Table
									columns={postColumn}
									tableData={posts?.map((item) => ({ ...item }))}
									sorting
									columnsButton
									padding="3rem"
									showTitle
									paginationType='normal'
									titleHeading="Legal & Regulatory Posts"
									showToolbar={true}
									pageSize={currentParams.limit}
									onChangeRowsPerPage={(event) => getPosts(parseInt(event.target.value, 10), 1)}
									totalRecords={currentParams.totalRecords}
									handlePageChange={(event, newPage) => getPosts(currentParams.limit, newPage + 1)}
									curPage={currentParams.page - 1}
								/>
							}
						</TabPanel>
						<TabPanel value="two">
							{isLoading ?
								<Box sx={{ m: '5rem' }}>
									<LinearProgress color="success" />
								</Box>
								:
								<Table
									columns={postColumn}
									tableData={posts?.map((item) => ({ ...item }))}
									sorting
									columnsButton
									padding="3rem"
									showTitle
									paginationType='normal'
									titleHeading="Useful Resources Posts"
									showToolbar={true}
									pageSize={currentParams.limit}
									onChangeRowsPerPage={(event) => getPosts(parseInt(event.target.value, 10), 1)}
									totalRecords={currentParams.totalRecords}
									handlePageChange={(event, newPage) => getPosts(currentParams.limit, newPage + 1)}
									curPage={currentParams.page - 1}
								/>
							}
						</TabPanel>
						<TabPanel value="three">
							{isLoading ?
								<Box sx={{ m: '5rem' }}>
									<LinearProgress color="success" />
								</Box>
								:
								<Table
									columns={newsColumn}
									tableData={govNews?.map((item) => ({ ...item }))}
									sorting
									columnsButton
									padding="3rem"
									showTitle
									paginationType='normal'
									titleHeading="General News"
									showToolbar={true}
									pageSize={currentParams.limit}
									onChangeRowsPerPage={(event) => getGovNews(parseInt(event.target.value, 10), 1)}
									totalRecords={currentParams.totalRecords}
									handlePageChange={(event, newPage) => getGovNews(currentParams.limit, newPage + 1)}
									curPage={currentParams.page - 1}
								/>
							}
						</TabPanel>
						{/* <TabPanel value="four">
						{isLoading ?
							<Box sx={{ m: '5rem' }}>
								<LinearProgress color="success" />
							</Box>
							:
							<Table
								columns={newsColumn}
								tableData={specificCompNews?.map((item) => ({ ...item }))}
								sorting
								columnsButton
								padding="3rem"
								showTitle
								paginationType='normal'
								titleHeading="Company Specific News"
								showToolbar={true}
							/>
						}
					</TabPanel> */}
					</TabContext>
				</Box>






			</Card>
		</>
	);
};

export default PendingRequests;
